import React, { useState } from 'react'

import { Header, Image } from 'semantic-ui-react'

import Data, { IntegrationProvider } from '../../api/Data'

import GoogleDriveIcon from '../../_images/cloud-googledrive-icon.svg'
import DropboxIcon from '../../_images/cloud-dropbox-icon.svg'
import OneDriveIcon from '../../_images/cloud-onedrive-icon.svg'

const CloudStorage = () => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  
  const openGoogleOAuth2Flow = async () => {
    // Set loading to true
    setIsLoading(true)

    const { data, error } = await Data.getIntegrationUrl(IntegrationProvider.GOOGLE)

    if (error) {
      console.error('Error getting Google OAuth2 URL', error)
      setIsLoading(false)
      return
    }

    // Generated auth url
    const url = data.url

    // Open the url in the current window
    window.open(url)

    // Set loading to false
    setIsLoading(false)
  }
  
  return (
    <>
      <Header as="h3">
        Cloud Storage
        <Header.Subheader>
          Bulk export your files to a connected external cloud storage.
        </Header.Subheader>
      </Header>
      
      <div style={{ display: 'flex', gap: '4rem', margin: '2rem 0 3rem 0' }}>
        <Image src={GoogleDriveIcon} onClick={!isLoading ? openGoogleOAuth2Flow : undefined} style={{ width: 64, height: 64, cursor: 'pointer' }} />
        <div>
          <Image src={DropboxIcon} style={{ width: 64, height: 64, opacity: 0.4 }} />
          <small>Coming Soon</small>
        </div>
        <div>
          <Image src={OneDriveIcon} style={{ width: 64, height: 64, opacity: 0.4 }} />
          <small>Coming Soon</small>
        </div>
      </div>
    </>
  )
}

export default CloudStorage
